import { LinkedInWizardData } from "@/pages/LinkedInWizard";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
interface LinkedInWizardStep1Props {
  data: LinkedInWizardData;
  updateData: (updates: Partial<LinkedInWizardData>) => void;
  onNext: () => void;
  onPrev: () => void;
}
const USER_CATEGORIES = ["Employee (Entry-Level to Mid-Level)", "Manager", "Director", "Executive (VP, C-Suite, Board)", "Consultant", "Coach", "Freelancer", "Agency Owner", "Business Owner", "Entrepreneur", "Job Seeker", "Career Changer", "Side Hustler", "Academic (Student, Professor, Researcher)", "Speaker / Author", "Industry Expert / Thought Leader", "Recruiter / Headhunter", "Investor / Advisor", "Government / Public Service", "Nonprofit / Advocacy"];
export function LinkedInWizardStep1({
  data,
  updateData
}: LinkedInWizardStep1Props) {
  const MAX_SELECTIONS = 2;

  const toggleCategory = (category: string) => {
    const currentCategories = data.userCategories || [];
    const isSelected = currentCategories.includes(category);
    if (isSelected) {
      updateData({
        userCategories: currentCategories.filter(c => c !== category)
      });
    } else {
      // Only allow adding if under the max limit
      if (currentCategories.length < MAX_SELECTIONS) {
        updateData({
          userCategories: [...currentCategories, category]
        });
      }
    }
  };
  return <div className="space-y-6">
      {/* Step Number and Header */}
      <div className="relative">
        <div className="absolute -top-2 -left-2">
          <div className="w-12 h-12 bg-linkedin rounded-full flex items-center justify-center shadow-linkedin">
            <span className="text-2xl font-bold text-white">1</span>
          </div>
        </div>
        <div className="ml-12">
          <h2 className="text-2xl font-bold mb-2 text-linkedin">Which of these best describes your current role?</h2>
          <p className="mb-6 text-gray-700">
            Select up to 2 categories that best represent how you want to be seen on LinkedIn.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {USER_CATEGORIES.map(category => {
        const isSelected = data.userCategories?.includes(category);
        const isAtLimit = (data.userCategories?.length || 0) >= MAX_SELECTIONS && !isSelected;
        return <Card 
          key={category} 
          className={`p-4 transition-all border-linkedin/20 ${
            isSelected 
              ? 'border-green-500 bg-green-50 dark:bg-green-950 ring-2 ring-green-200 shadow-md cursor-pointer' 
              : isAtLimit 
                ? 'border-gray-200 bg-gray-50 dark:bg-gray-900 opacity-50 cursor-not-allowed' 
                : 'border-gray-200 bg-gray-100 dark:bg-gray-800 hover:border-linkedin/50 hover:bg-gray-200 dark:hover:bg-gray-700 hover:shadow-md cursor-pointer'
          }`} 
          onClick={() => !isAtLimit && toggleCategory(category)}
        >
              <div className="flex items-center justify-between">
                <span className={`text-sm font-medium ${isSelected ? 'text-green-800 dark:text-green-200' : isAtLimit ? 'text-gray-400' : 'text-linkedin dark:text-linkedin'}`}>{category}</span>
                {isSelected && <Badge variant="default" className="bg-green-600 hover:bg-green-700 text-white">
                    Selected
                  </Badge>}
              </div>
            </Card>;
      })}
      </div>

      {data.userCategories && data.userCategories.length > 0 && <div className="mt-6 p-4 bg-linkedin-light dark:bg-linkedin-dark/20 rounded-lg border border-linkedin/20">
          <p className="text-sm font-medium text-linkedin mb-2">
            Selected Categories ({data.userCategories.length}/{MAX_SELECTIONS}):
          </p>
          <div className="flex flex-wrap gap-2">
            {data.userCategories.map(category => <Badge key={category} variant="secondary" className="text-xs bg-white border-linkedin/20">
                {category}
              </Badge>)}
          </div>
        </div>}
    </div>;
}